import { ActivationAttempt, CardType, GameState, PreparedCard } from '../types'
import { getCardEffect } from './effects'

const normalizeRotation = (rotation: number): number => (rotation % 360 + 360) % 360

export const isSpikesCard = (preparedCard: PreparedCard): boolean => {
  const card = preparedCard.card
  return card.type === CardType.Defense &&
    card.subType === 'Armory' &&
    ((card as any).faceSlug === 'spikes' || (card.extendedShield && card.value === 0 && card.essenceCost === 6))
}

export const isProtectorAttackMode = (preparedCard: PreparedCard): boolean => {
  return getCardEffect(preparedCard).type === CardType.Protector &&
    normalizeRotation(preparedCard.rotation) > 90 &&
    normalizeRotation(preparedCard.rotation) < 270
}

export const isDelayedDamageSource = (preparedCard: PreparedCard): boolean => {
  const type = getCardEffect(preparedCard).type
  return type === CardType.Disease || type === CardType.NaturalGrip
}

export const isImmediateDamageSource = (preparedCard: PreparedCard): boolean => {
  const type = getCardEffect(preparedCard).type
  return [
    CardType.Attack,
    CardType.EnergySword,
    CardType.FlyingScythe,
    CardType.InfernoGauntlet,
    CardType.Larcendagger,
    CardType.LifeDrain,
    CardType.Chromabow,
    CardType.Trembling,
    CardType.PlantedBomb,
  ].includes(type) || isSpikesCard(preparedCard) || isProtectorAttackMode(preparedCard)
}

export const isImmediateOrReflectedDamageSource = (preparedCard: PreparedCard): boolean => {
  return isImmediateDamageSource(preparedCard) || getCardEffect(preparedCard).type === CardType.Counterblast
}

export const canCounterblastTarget = (preparedCard: PreparedCard, counterblastOwnerId: number): boolean => {
  if (preparedCard.card.ownerId === counterblastOwnerId) return false
  if (isDelayedDamageSource(preparedCard)) return false
  if (getCardEffect(preparedCard).type === CardType.Counterblast) return false
  return isImmediateDamageSource(preparedCard)
}

export const countsForSpikesAttempt = (preparedCard: PreparedCard): boolean => {
  const type = getCardEffect(preparedCard).type
  if (type === CardType.Counterblast || isSpikesCard(preparedCard)) return false
  return isImmediateDamageSource(preparedCard)
}

export const getCurrentActivationTargetCard = (activation: ActivationAttempt): PreparedCard => {
  return activation.counterChain.length > 0
    ? activation.counterChain[activation.counterChain.length - 1]
    : activation.attackingCard
}

export const getValidCounterblastActivationIds = (state: GameState, playerId: number): string[] => {
  return state.activations
    .filter(activation => !activation.resolved && !activation.accepted)
    .filter(activation => canCounterblastTarget(getCurrentActivationTargetCard(activation), playerId))
    .map(activation => activation.attackingCard.card.id)
}

export const getImmediateDamageAmount = (
  preparedCard: PreparedCard,
  activation: ActivationAttempt,
  state: GameState
): number => {
  const effect = getCardEffect(preparedCard)
  if (effect.type === CardType.Trembling) {
    const targetId = activation.targetId ?? (preparedCard.card.ownerId === 1 ? 2 : 1)
    const target = state.players.find(player => player.id === targetId)
    return state.preparedAtNightStart?.[targetId] ?? target?.prepared.length ?? 0
  }
  if (isSpikesCard(preparedCard)) return 0
  return effect.value || 0
}
